import React, { useEffect } from "react";
import { View, Text, StyleSheet, TouchableOpacity } from "react-native";
import { globalFontStyle } from "../../../assets";
import Colors from "../../../assets/Color/Colors";
import Width from "../../../assets/Width";
import { delete_icon } from "../../../utils/images";
import { Network } from "../../../utils/network";
import Toast from "react-native-toast-message";
import { getBankDetails, getUser } from "../../Profile/redux/profile.action";
import { useDispatch } from "react-redux";
import FastImage from "../../../common/FastImage";
import { isMobile } from "../../../utils/commonMethods";
import {globalConfigurableData, GlobalScreens} from "../../../utils/globalConstant";

const DeleteBank = ({ onbankdelete, paymentGateway }) => {
  const dispatch = useDispatch();
  const onDeleteAcc = async () => {
    const res = await Network.deleteAcc({ pg: paymentGateway?.value }, true);
    if (res?.data?.success) {
      dispatch(getUser());
      dispatch(getBankDetails());
      Toast.show({
        type: "info",
        text1: '"Selected bank deleted successfully!"',
        visibilityTime: 2000,
        position: "bottom",
      });
    } else {
      const error = res?.data?.error || "Error";
      Toast.show({
        type: "info",
        text1: error,
        visibilityTime: 2000,
        position: "bottom",
      });
    }
    onbankdelete();
  };
  const onDiscardDelete = () => {
    onbankdelete();
  };
  return (
    <View
      style={[
        {
          paddingHorizontal: 17,
          paddingVertical: 17,
        },
        isMobile() ? { width: Width.width } : { width: Width.width / 2 },
      ]}>
      <View style={{ flexDirection: "row", marginBottom: 10 }}>
        <FastImage style={styles.deleteStyle} source={delete_icon()} />
        <Text style={{color: globalConfigurableData.primaryTextColor1}}>DELETE BANK</Text>
      </View>

      <Text style={{color: globalConfigurableData.primaryTextColor1}}>Do you want to delete bank details?</Text>
      <View style={{ flexDirection: "row", justifyContent: "flex-end" }}>
        <TouchableOpacity style={{ marginRight: 15 }} onPress={onDeleteAcc}>
          <Text style={styles.yesText}>Yes</Text>
        </TouchableOpacity>
        <TouchableOpacity onPress={onDiscardDelete}>
          <Text style={[styles.yesText, { color: globalConfigurableData.errorTextColor1 }]}>No</Text>
        </TouchableOpacity>
      </View>
    </View>
  );
};

export default DeleteBank;

const styles = StyleSheet.create({
  deleteStyle: {
    width: 20,
    height: 20,
  },
  yesText: {
    ...globalFontStyle.appFontSubHeading,
    color: GlobalScreens.Wallet.highlightColor,
  },
});
